import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { flashItems } from '@/mocks/home';

const filters = [
  { key: 'all', label: '全部快讯' },
  { key: 'hot', label: '热评最多' },
  { key: 'new', label: '刚冒出来的' },
];

const levelStyle: Record<string, string> = {
  hot: 'bg-primary-500',
  new: 'bg-accent-500',
  normal: 'bg-secondary-500',
};

export default function FlashTimeline() {
  const [active, setActive] = useState('all');

  const list = flashItems.filter((item) => (active === 'all' ? true : item.level === active));

  return (
    <section id="flash" className="scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            no="01"
            english="Live Feed"
            title="实时快讯流"
            desc="一条一条往下滚，时间倒序排列。看到眼熟的标题，直接进讨论区接着聊。"
          />

          <div className="flex w-full gap-1 rounded-full border border-background-300 bg-background-100 p-1 lg:w-auto">
            {filters.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={
                  'flex-1 cursor-pointer whitespace-nowrap rounded-full px-4 py-2 font-label text-xs transition-colors lg:flex-none md:text-sm ' +
                  (active === tab.key
                    ? 'bg-foreground-950 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900')
                }
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 mx-auto max-w-3xl">
          <ul className="relative">
            <span className="absolute left-[5px] top-2 bottom-2 w-px bg-background-300" />
            {list.map((item) => (
              <li key={item.id} className="relative flex gap-5 pb-9 pl-0 last:pb-0">
                <span className="relative z-10 mt-1.5 flex h-3 w-3 shrink-0 items-center justify-center">
                  <span className={`h-2.5 w-2.5 rounded-full ${levelStyle[item.level]} ring-4 ring-background-50`} />
                </span>
                <div className="min-w-0 flex-1 border-b border-dashed border-background-200 pb-8 last:border-0 last:pb-0">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                    <time className="font-heading text-lg font-bold text-foreground-950">{item.time}</time>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">{item.tag}</span>
                    {item.level === 'hot' && (
                      <span className="flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 font-label text-[11px] text-primary-700">
                        <i className="ri-fire-fill" />
                        热度领先
                      </span>
                    )}
                    <span className="ml-auto flex items-center gap-1 font-label text-[11px] text-foreground-500">
                      <i className="ri-bar-chart-line" />
                      {item.heat.toLocaleString()}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-900 md:text-xl">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex justify-center">
            <button
              type="button"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-refresh-line" />
              加载更早的快讯
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}